import { useEffect, useState } from "react";
import parse from "html-react-parser";
import { GetOrganizationTokenRequest } from "api/UsersController";
import {
  ButtonA,
  ButtonAccessability,
} from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./signInOrg.module.scss";

interface BelongToOrgErrorComponentI {
  email: string;
  setEmailNotBelongToOrg: (value: string) => void;
}

const BelongToOrgErrorComponent = ({
  email,
  setEmailNotBelongToOrg,
}: BelongToOrgErrorComponentI) => {
  const { getTextByKey } = useContent();

  const [inviteToken, setInviteToken] = useState("");

  // orgName is last 2 parts of the hostname splited by dots, for example "fileshare.perspective-media.info" -> "perspective-media.info"
  const orgName = window.location.hostname.split(".").slice(-2).join(".");

  const textReplacedKeys = getTextByKey("belong-to-org-error-text")
    .replace("#useremail#", email)
    .replace("#orgname#", orgName);

  const handleBack = () => {
    setEmailNotBelongToOrg("");
  };

  const getInviteToken = async () => {
    const response = await GetOrganizationTokenRequest();
    if (response.data) {
      setInviteToken(response.data);
    }
  };

  useEffect(() => {
    getInviteToken();
  }, [email]);

  return (
    <>
      <h3 className={styles.belongToOrgErrorTitle}>
        {getTextByKey("belong-to-org-error-title")}
      </h3>
      <p className={styles.belongToOrgErrorText}>{parse(textReplacedKeys)}</p>
      {/* @ts-ignore */}
      <ButtonA
        page={`invite/${inviteToken}`}
        buttonClass={styles.joinOrgButton}
      >
        {getTextByKey("invite-to-org")}
      </ButtonA>
      {/* @ts-ignore */}
      <ButtonAccessability
        onClick={handleBack}
        buttonClassName={styles.backButton}
      >
        {getTextByKey("back-to-login")}
      </ButtonAccessability>
    </>
  );
};

export default BelongToOrgErrorComponent;
